"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addItemToArray = addItemToArray;
exports.updateItemInArray = updateItemInArray;
exports.removeItemFromArray = removeItemFromArray;

function addItemToArray(array, index, item) {
  return array.slice(0, index).concat([item]).concat(array.slice(index));
}

function updateItemInArray(array, index, item) {
  return array.slice(0, index).concat([item]).concat(array.slice(index + 1));
}

function removeItemFromArray(array, index) {
  return array.slice(0, index).concat(array.slice(index + 1));
}